<template>
  <div class="pay">
    <div class="pay_concent">
      <div class="pay_success">
        <div class="payitem">
          <img
            src="https://smart-nm.oss-cn-qingdao.aliyuncs.com/ydp/success.png"
            class="imgsuccess"
          />
          <div class="successsfont">支付成功</div>
        </div>
      </div>

      <div class="pay_concent2">
        <div class="pay_concent3">
          <div class="pay_concent4">
            <div>收 款 方</div>
            <div class="pay_concent5">{{ list.merchant || "暂无" }}</div>
          </div>

          <div class="pay_concent4">
            <div>订 单 号</div>
            <div class="pay_concent5">
              {{ list.order_no || "暂无订单尾号" }}
            </div>
          </div>

          <div class="pay_concent4">
            <div>支付总额</div>
            <div class="pay_concent6">
              <span>￥</span>{{ list.pay_amount || "暂无" }}
            </div>
          </div>
        </div>
      </div>
    </div>
     <div class="concent3">
      <button class="concent4" @click="zhifu_success">
        <!-- <p>立</p> <p>刻</p> -->
         <p>关</p> <p>闭</p> 
        <!-- <span class="span1">({{timeshow}}秒后自动关闭)</span> -->


       <!-- <span class="spanabs2"><van-loading type="spinner" /></span> -->
      </button>
    </div>

    <template  v-if="ad_urlisshow">
    <div class="concent"  v-for="(item,index) in list.ad_url" :key="index">
      <div class="concent2">
        <a :href="item.jump_to" target="_blank">
         <img :src="item.url" class="concent2img" />
        </a>
      </div>
    </div>
    </template>

   
  </div>
</template>

<script>
var Interval
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
var typeBower = null;
import { getpaysuccesss } from "@/api/pay";

export default {
  name: "pay_success",
  data() {
    return {
      list: {},
      url: null,
      ad_urlisshow: null,
      timeshow:6,
    };
  },

  created() {
    let order_no = this.$route.query.order_number;
    this.url = location.href;
    getpaysuccesss({ order_no }).then((res) => {
      if (res.resultCode == 1) {
        // console.log(res);
        this.list = res.resultInfo;
        if (this.list.ad_url.length > 0) {
          this.ad_urlisshow = true;
        } else {
          this.ad_urlisshow = false;
        }
      }
    });


  },
  mounted() {
    setTimeout(()=>{
     if(this.iswx() == "wx") {
        WeixinJSBridge.invoke("closeWindow", {}, function (e) {});
      }
      if (this.iswx() == "ali") {
        AlipayJSBridge.call("closeWebview");
      };

    },0)


// let num =6
// var times=null;
// times=setInterval(() => {
// num--
// this.timeshow=num
// if(num<=0){
// clearInterval(times)
// if(this.iswx() == "wx") {
//         WeixinJSBridge.invoke("closeWindow", {}, function (e) {});
//       }
//       if (this.iswx() == "ali") {
//         AlipayJSBridge.call("closeWebview");
//       };
// return false;
// }
// },1000);





    Interval=setInterval(() => {
     this.timeshow=this.timeshow--;
     if(this.time==0){
     clearInterval(Interval)
     }
   }, 1000);
  },
  methods: {
    iswx() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/Alipay/i) == "alipay") {
        // console.log(111);
        typeBower = "ali";
      }
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        typeBower = "wx";
        // console.log(222);
      }
      // console.log(typeBower);
      return typeBower;
    },
    zhifu_success() {
      if (this.iswx() == "wx") {
        WeixinJSBridge.invoke("closeWindow", {}, function (e) {});
      }
      if (this.iswx() == "ali") {
        AlipayJSBridge.call("closeWebview");
      };
    },
    
  },
};
</script>
<style lang="less" scoped>
.pay {
  width: 100vw;
  height: 100vh;
  background-color: #f9f9f9;
}
.pay_concent {
  width: 100vw;
  height: 5.4rem;
  background: #ffffff;
  border-radius: 0px 0px 0.16rem 0.16rem;
}
.pay_success {
  width: 100vw;
  height: 2.9rem;
  display: flex;
  justify-content: center;
  align-content: center;
}
.payitem {
  width: 5.9rem;
  //   height:1.76rem;
  border-bottom: solid 1px #eeeeee;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.imgsuccess {
  width: 2.4rem;
  height: 1.8rem;
  margin-top: 0.2rem;
}
.successsfont {
  font-size: 0.36rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4a4a4a;
  margin-top: 0.2rem;
}
.pay_concent2 {
  width: 100vw;
  height: 2.5rem;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pay_concent3 {
  width: 5.9rem;
  height: 3.0rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.pay_concent4 {
  display: flex;
  justify-content: space-between;
}
.pay_concent4 div:first-child {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.pay_concent5 {
  font-size: 0.28rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.pay_concent6 {
  font-size: 0.4rem;
  font-family: OPPOSans-B, OPPOSans;
  font-weight: 600;
  color: #ff0000;
}
.pay_concent6 span {
  font-size: 0.28rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ff0000;
}
.concent {
  position: relative;
  width: 100vw;
  height: 2.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.2rem;
  // background-color: #f9f9f9;
  overflow: hidden;
  border:none;
}
.concent2 {
  width: 6.9rem;
  height: 2.4rem;
  // background: linear-gradient(135deg, #ff7a00 0%, #ff171b 100%);
  border-radius: 0.16rem;
  overflow: hidden;
  border: none;
  // background-color: #f9f9f9;
  border:none;
}

.concent3 {
  position: relative;
  width: 100vw;
  height: 0.88rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
}
.concent4 {
  width: 6.9rem;
  height: 100%;
  background: linear-gradient(90deg, #6dd572 0%, #58b85c 100%);
  border-radius: 0.16rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.4rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  left:0.04rem;
  border: none;
  margin-top:0.6rem;
	// letter-spacing:0.2rem;
}
.span1{
   font-size: 0.28rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}

.concent4 p{
  margin:0.1rem;
}
.spanabs2{
 margin-left:-0.6rem;
}
.concent2img {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
</style>